import React from "react";
import ImageUpload from "./ImageUpload";
import { handleRemoveVariantImage } from "./handlers";
import { REWARD_TYPES, hasVariantsWithQuantity, hasPricingAndQuantityFields } from "./utils";

const VariantRow = ({
  variant,
  index,
  setVariants,
  handleImageUpload,
  handleVariantImageUpload,
  updateVariant,
  opts,
  canAddVariants
}) => {
  const renderPriceAndQuantity = () => (
    hasPricingAndQuantityFields(opts) && (
      <>
        <td className="text-center">
          <input
            type="number"
            className="form-control reward-variant-face-value"
            id={`reward_variants_attributes_${index}_face_value`}
            value={variant.faceValue ?? ''}
            onChange={e => updateVariant(e, variant.id, "faceValue", e.target.value, setVariants)}
            disabled={!variant.enabled || canAddVariants}
          />
        </td>
        <td className="text-center">
          <input
            type="number"
            className="form-control reward-variant-quantity"
            id={`reward_variants_attributes_${index}_quantity`}
            value={variant.quantity ?? ''}
            placeholder="Quantity (optional)"
            onChange={e => updateVariant(e, variant.id, "quantity", parseInt(e.target.value, 10), setVariants)}
            disabled={!variant.enabled || canAddVariants}
          />
        </td>
      </>
    )
  );

  const renderSKU = () => (
    opts.reward_type === REWARD_TYPES.COMPANY_FULFILLED && (
      <td className="text-center">
        <input
          type="text"
          className="form-control reward-variant-sku"
          id={`reward_variants_attributes_${index}_sku`}
          value={variant.sku || ''}
          onChange={e => updateVariant(e, variant.id, "sku", e.target.value, setVariants)}
          disabled={!variant.enabled}
          placeholder="SKU (optional)"
        />
      </td>
    )
  );

  const renderRedemptionCount = () => (
    hasVariantsWithQuantity(opts) && (
    <td className="text-center">
      {variant.redemptionCount !== undefined && variant.redemptionCount !== null ? (
        <p className="text-secondary mb-0">
          Redeemed {variant.redemptionCount} times already
        </p>
      ) : null}
    </td>
    )
  );

  return (
    <tr 
      className={`align-middle reward_variants_attributes ${variant.enabled ? 'bg-light' : ''}`}
      id={`reward_variants_attributes_${index}`}
      style={{ height: '40px' }}
    >
      <td></td>
      <td>
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <ImageUpload
              value={variant.image}
              onChange={(e) => handleImageUpload(e, handleVariantImageUpload, variant, setVariants)}
              onRemove={(e) => handleRemoveVariantImage(e, variant, setVariants)}
              disabled={!variant.enabled || canAddVariants}
            />
          </div>
          <div className="flex-grow-1 ms-2 text-truncate" title={variant.label}>
            {variant.label}
          </div>
        </div>              
      </td>
      {renderPriceAndQuantity()}
      {renderSKU()}
      {hasVariantsWithQuantity(opts) && (
        renderRedemptionCount()
      )}
    </tr>
  );
};

export default VariantRow;